<template>
<div>
  <v-layout key="0" v-if="!loading" row wrap justify-center>
    <v-flex class="py-3" xs12 sm10 md6>
      <v-text-field
        label="Task Name"
        v-model.trim="newName"
        hide-details
      ></v-text-field>
    </v-flex>
    <v-flex xs12></v-flex>
    <v-flex class="pb-3 text-xs-center" xs12>
      <v-btn
        @click.native="canUpdateName"
        color="success"
        :loading="updating"
        :disabled="updating"
        depressed
      ><b>Update Name</b></v-btn>
      <v-btn
        @click.native="popup.type = 'Resetting', popup.show = true"
        color="error"
        flat
      ><b>Reset Name</b></v-btn>
    </v-flex>
    <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
      <v-btn @click.native="setupDeleteTask()" color="error" :disabled="deleting" :loading="deleting" large>Delete Task</v-btn>
    </v-flex>
    <v-flex class="pb-3" xs12>
      <v-divider></v-divider>
    </v-flex>
  </v-layout>
  <v-layout key="a" v-if="loading" row justify-center>
    <v-flex class="text-xs-center py-5 my-5" xs12>
      <v-progress-circular color="accent" indeterminate></v-progress-circular>
    </v-flex>
  </v-layout>
  <v-layout key="b" v-else-if="videoUrl == ''" row wrap justify-center>
    <v-flex class="pb-5 text-xs-center" xs12 md8>
      <div class="py-5">
        <input class="inputfile" @change="chooseFile($event)" type="file" id="lectureVideo" :disabled="!upload.ready">
        <label 
          for="lectureVideo"
          :style="!upload.ready ? '' : 'cursor: pointer'"
          :class="!upload.ready ? 'btn grey grey--text text--lighten-4 px-4 py-2 mb-1 elevation-0' : 'btn primary px-4 py-2 mb-1 elevation-0'"
        >
          <b>Select a File</b>
        </label>
        <v-text-field
          label="Selected Video"
          class="mx-2"
          v-model="upload.fileDetails"
          :append-icon="upload.file ? 'close' : ''"
          :append-icon-cb="() => (resetFileInput())"
          readonly
          hide-details
        ></v-text-field>
      </div>
      <div v-if="upload.ready">
        <v-btn @click.native="uploadVideo" color="success" depressed large>
          <v-icon class="mr-2" color="grey lighten-5" small>fas fa-upload</v-icon>
          <b>Upload</b>
        </v-btn>
      </div>
      <v-layout v-else-if="upload.inProgress" row wrap justify-center>
        <v-flex class="title" xs12>
          <v-btn v-if="upload.status != 'DONE'" @click.native="cancelUpload()" class="my-0" color="error" small flat><b>Cancel</b></v-btn>
        </v-flex>
        <v-flex class="pb-2" xs12 md4>
          <v-progress-linear :color="upload.status == 'DONE' ? 'success' : 'primary'" :value="upload.loadPercent"></v-progress-linear>
        </v-flex>
        <v-flex class="title pb-3" xs12>
          <b>{{upload.status == 'DONE' ? 'Finishing up...' : upload.loadPercent + '%'}}</b>
        </v-flex>
      </v-layout>
      <div :key="3" v-else-if="upload.canceled">
        <div class="title pb-2"><b>Upload Canceled</b></div>
        <v-btn @click.native="load(), resetFileInput()" color="success" depressed>Reset</v-btn>
      </div>
    </v-flex>
  </v-layout>
  <v-layout v-else key="c" @contextmenu.prevent="" :class="loading ? 'invisible' : ''" row wrap justify-center>
    <v-flex class="py-4 text-xs-center" xs12 md10>
      <video id="lecture-player" class="video-js lecture-video" preload="auto" data-setup='{}' controls>
        <source type="video/mp4" :src="videoUrl">
      </video>
      <div class="mt-4" v-if="deleting">
        <div class="title pb-2">Deleting Video</div>
        <div class="subheading pb-2">Are you sure?</div>
        <v-btn @click.native="deleteVideo()" color="error" :disabled="deleteLoading" :loading="deleteLoading" depressed><b>Delete</b></v-btn>
        <v-btn @click.native="deleting = false" color="error" flat><b>Cancel</b></v-btn>
      </div>
      <v-btn v-else @click.native="deleting = true" class="mt-4" color="error" large>Delete Video</v-btn>
    </v-flex>
  </v-layout>

  <r-task-popup
    :popup="popup"
    :task-data="newTask"
    :deleting-data="toDelete"
  ></r-task-popup>
</div>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/storage'
import videojs from 'video.js'
import TaskPopup from './TaskPopup.vue'
import {contentEvent} from '../../main'
export default {
  components: {
    rTaskPopup: TaskPopup
  },
  data: () => ({
    loading: true,
    updating: false,
    taskRef: null,
    taskData: {},
    newTask: {},
    newFileName: '',
    newName: '',
    videoUrl: '',
    video: null,
    deleting: false,
    deleteLoading: false,
    toDelete: null,
    upload: {
      ready: true,
      inProgress: false,
      canceled: false,
      input: null,
      file: null,
      fileDetails: '',
      task: null,
      status: '',
      loadPercent: 0
    },
    popup: {
      show: false,
      tpye: ''
    }
  }),
  mounted () {
    contentEvent.$off()
    this.load()
    contentEvent.$on('reset', () => {
      this.resetNewName()
    })
    contentEvent.$on('updateTask', () => {
      this.updateTask()
    })
    contentEvent.$on('delete', () => {
      this.deleteTask()
    })
  },
  updated () {
    if (this.video === null && this.videoUrl !== '') {
      try {
        this.video = videojs('lecture-player')
      } catch (err) {}
    }
  },
  beforeDestroy () {
    if (this.video) this.video.dispose()
  },
  methods: {
    load () {
      this.loading = true
      const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
      let sectionData = {}
      for (let s of this.$store.getters.sectionByContent(contentData.key)) {
        if (s.url === this.$route.params.sectionUrl) sectionData = s
      }
      for (let t of this.$store.getters.taskBySection(sectionData.key)) {
        if (t.url === this.$route.params.taskUrl) this.taskData = t
      }
      this.newTask = {
        ...this.taskData,
        fileName: this.taskData.fileName ? this.taskData.fileName : '',
        fileDetails: this.taskData.fileDetails ? this.taskData.fileDetails : ''
      }
      this.resetNewName()
      this.videoRef = firebase.storage().ref().child('lectures').child(this.taskData.key)
      if (this.newTask.fileName.length > 0) {
        let fileRef = this.videoRef.child(this.newTask.fileName)
        fileRef.getDownloadURL().then(downloadUrl => {
          this.videoUrl = downloadUrl
          this.loading = false
        })
      } else {
        this.videoUrl = ''
        this.loading = false
      }
    },
    resetNewName () {
      this.newName = this.taskData.name
    },
    canUpdateName () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newName !== this.taskData.name) {
        if (this.newName === '' || this.newName.toLowerCase() === 'create') {
          appMsg.msg = this.newName === '' ? 'Please enter a name for the task' : 'That name is reserved, please use a different name'
          this.$store.dispatch('showAppMsg', appMsg)
          return
        } else {
          const contentData = this.$store.getters.contentByUrl(this.$route.params.contentUrl)
          let sectionData = {}
          for (let s of this.$store.getters.sectionByContent(contentData.key)) {
            if (s.url === this.$route.params.sectionUrl) sectionData = s
          }
          for (let t of this.$store.getters.taskBySection(sectionData.key)) {
            if (t.name.toLowerCase() === this.newName.toLowerCase()) {
              appMsg.msg = 'That name is already in use, please use a different name'
              this.$store.dispatch('showAppMsg', appMsg)
              return
            }
          }
        }
        this.popup = {
          show: true,
          type: 'Updating Task'
        }
      } else {
        appMsg.msg = 'No change detected'
        this.$store.dispatch('showAppMsg', appMsg)
      }
    },
    updateTask () {
      this.updating = true
      const task = {
        ...this.newTask,
        name: this.newName,
        url: this.$store.getters.formatUrl(this.newName.toLowerCase())
      }
      this.$store.dispatch('updateTask', task).then(() => {
        const appMsg = {
          type: 'success',
          msg: this.taskData.name + ' updated'
        }
        this.updating = false
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
        this.popup.show = false
      })
    },
    setupDeleteTask () {
      this.toDelete = {...this.taskData}
      this.popup = {
        show: true,
        type: 'Deleting Task'
      }
    },
    deleteTask () {
      this.deleting = true
      const taskName = this.toDelete.name
      this.$store.dispatch('deleteTask', this.toDelete).then(() => {
        const appMsg = {
          type: 'success',
          msg: taskName + ' has been deleted'
        }
        this.deleting = false
        this.$router.push('/content/' + this.$route.params.contentUrl + '/' + this.$route.params.sectionUrl)
        this.$store.dispatch('showAppMsg', appMsg)
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleting = false
      })
    },
    resetFileInput () {
      if (this.upload.input) this.upload.input.value = ''
      this.upload = {
        ready: true,
        inProgress: false,
        canceled: false,
        input: null,
        file: null,
        fileDetails: '',
        task: null,
        status: '',
        loadPercent: 0
      }
    },
    chooseFile (event) {
      this.upload.fileDetails = ''
      this.upload.input = event.target
      if (this.upload.input.files.length > 0) {
        this.upload.file = this.upload.input.files[0]
        let size = this.humanFileSize(this.upload.file.size)
        let fileArr = this.upload.file.name.split('.')
        let ext = fileArr[fileArr.length - 1]
        if (ext === 'mp4') {
          this.upload.fileDetails += this.upload.file.name + ', File size: ' + size
        } else {
          const appMsg = {
            type: 'error',
            msg: 'File type not supported'
          }
          this.$store.dispatch('showAppMsg', appMsg)
          this.resetFileInput()
        }
      }
    },
    humanFileSize (bytes) {
      // Credit to 'mpen' on stack overflow
      var thresh = 1024
      if (Math.abs(bytes) < thresh) {
        return bytes + ' B'
      }
      var units = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      var u = -1
      do {
        bytes /= thresh
        ++u
      } while (Math.abs(bytes) >= thresh && u < units.length - 1)
      return bytes.toFixed(1) + ' ' + units[u]
    },
    setUploadState (state) {
      if (state === 'ready') {
        this.upload.ready = true
        this.upload.inProgress = false
        this.upload.canceled = false
      } else if (state === 'inProgress') {
        this.upload.ready = false
        this.upload.inProgress = true
        this.upload.canceled = false
      } else if (state === 'canceled') {
        this.upload.ready = false
        this.upload.inProgress = false
        this.upload.canceled = true
      }
    },
    uploadVideo () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (!this.upload.file) {
        appMsg.msg = 'No file selected'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      let fileRef = this.videoRef.child(this.upload.file.name)
      this.upload.task = fileRef.put(this.upload.file)
      this.setUploadState('inProgress')
      this.upload.task.on('state_changed',
        snapshot => {
          this.upload.loadPercent = ((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(1)
        },
        error => {
          appMsg.msg = error.message
          this.$store.dispatch('showAppMsg', appMsg)
          this.setUploadState('canceled')
        },
        () => {
          this.upload.status = 'DONE'
          this.upload.task.snapshot.ref.getDownloadURL().then(downloadUrl => {
            this.newFileName = this.upload.file.name
            const task = {
              ...this.newTask,
              fileName: this.newFileName,
              fileDetails: this.upload.fileDetails
            }
            this.$store.dispatch('updateTask', task).then(() => {
              const appMsg = {
                type: 'success',
                msg: 'Video uploaded to ' + this.newTask.name
              }
              this.$store.dispatch('showAppMsg', appMsg)
              this.load()
              this.$forceUpdate()
            })
          })
        }
      )
    },
    cancelUpload () {
      this.upload.task.cancel()
    },
    deleteVideo () {
      this.deleteLoading = true
      this.$store.dispatch('deleteVideo', this.newTask).then(() => {
        const task = {
          ...this.newTask,
          fileName: '',
          fileDetails: ''
        }
        this.$store.dispatch('updateTask', task).then(() => {
          const appMsg = {
            type: 'success',
            msg: 'Video deleted from ' + this.newTask.name
          }
          this.deleteLoading = false
          this.deleting = false
          this.load()
          this.video.dispose()
          this.video = null
          this.resetFileInput()
          this.$forceUpdate()
          this.$store.dispatch('showAppMsg', appMsg)
        })
      }).catch(err => {
        const appMsg = {
          type: 'error',
          msg: err.message
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.deleteLoading = false
      })
    }
  }
}
</script>

<style>
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.lecture-video {
  max-width: 100%;
  height: 375px;
}
.invisible {
  width: 0.1px  !important;
  height: 0.1px  !important;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/content/LectureTask.vue